<template>
  <div class="life-recad">
    <InnerHeader :cover="require('../../assets/img/life_recad/cover.jpg')" :bgColor="'#6E5925'" bgPosition="center 15%"
      :links="links" />

    <main>
      <template v-if="$route.query.page !== 'news' && !$route.query.id">
        <div class="decoration-element">
          <div class="decoration-element-2"></div>
        </div>

        <div class="row row-1">
          <div class="img-and-text">
            <img class="row-1-top-img" src="@/assets/img/life_recad/logo.svg" />
          </div>
          <div class="right">
            <img class="row-1-top-img" v-if="$i18n.locale === 'bg'" src="../../assets/img/life_recad/flag_bg.svg" />
            <img class="row-1-top-img" v-if="$i18n.locale === 'en'" src="../../assets/img/life_recad/flag_en.svg" />
            <img class="row-1-top-img" src="@/assets/img/life_recad/natura.svg" />
          </div>
        </div>
      </template>

      <NewsPreview v-if="$route.query.id" />
      <template v-else>
        <About v-if="!$route.query.page" />
        <Documents v-else-if="$route.query.page === 'documents'" />
        <News v-else-if="$route.query.page === 'news'" />
        <Contacts v-else-if="$route.query.page === 'contacts'" />
      </template>
    </main>
  </div>
</template>

<script>
import InnerHeader from "../shared/InnerHeader";
import About from "./About";
import Documents from "./Documents.vue";
import News from "../news/News.vue";
import NewsPreview from "../news/NewsPreview.vue";
import Contacts from "./Contacts.vue";

export default {
  components: {
    InnerHeader,
    About,
    Documents,
    News,
    NewsPreview,
    Contacts,
  },
  computed: {
    links() {
      return [
        {
          name: this.$t("nav8-1"),
          url: "/life-recad",
        },
        {
          name: this.$t("nav8-2"),
          url: "/life-recad?page=documents",
        },
        {
          name: this.$t("nav8-3"),
          url: "/life-recad?page=news",
        },
        {
          name: this.$t("nav8-4"),
          url: "/life-recad?page=contacts",
        },
      ];
    },
  },
  mounted() {
    document.title = this.$t("title8");
  },
  destroyed() {
    document.title = this.$t("title0");
  },
};
</script>

<style lang="scss" scoped>
.life-recad {
  main {
    position: relative;
  }

  .row {
    z-index: 1;
    position: relative;
  }

  .row-1 {
    align-items: stretch;
    padding-bottom: 0;

    .right {
      align-items: center;
      display: flex;
      gap: 1rem;
      justify-content: flex-end;
      margin-top: 2%;
      margin-left: 3%;
      padding-right: $sidesPadding;
      width: 47%;
    }
  }
}

@media screen and (max-width: 1600px) {
  .life-recad {
    .row-1 {
      .right {
        padding-right: $sidesPadding1600;
      }
    }
  }
}

@media screen and (max-width: 1280px) {
  .life-recad {
    .row-1 {
      .right {
        padding-right: $sidesPadding1280;
      }
    }
  }
}

@media screen and (max-width: 1000px) {
  .life-recad {
    .row-1 {
      align-items: center;

      .img-and-text {
        padding-bottom: 0;

        .text-group {
          margin: 0;
          padding: $sidesPadding1280;
        }
      }

      .right {
        img {
          width: 20vw;
        }
      }

      .row-img {
        display: block;
        height: auto;
        width: 50%;
      }
    }
  }
}

@media screen and (max-width: 800px) {
  .life-recad {
    .row-1 {
      padding: 0;
      flex-direction: column;

      .img-and-text {
        display: flex;
        justify-content: center;
        padding: 2rem;
      }

      .text-group {
        width: 100%;
        padding: $sidesPadding1280;
      }

      .row-img,
      .img-and-text {
        margin: 0;
        width: 100%;
      }

      .img-and-text .text-group p:last-of-type {
        margin-bottom: 0;
      }

      .row-1-top-img {
        width: 80%;
      }

      .right {
        margin: 0;
        padding: 0;
        width: 100%;
        justify-content: center;

        img {
          width: calc(40% - 10px);
        }
      }
    }
  }
}

@media screen and (max-width: 600px) {
  .life-recad {
    .row-1 {

      .text-group,
      .img-and-text .text-group {
        padding: $sidesPadding600;
      }
    }
  }
}
</style>
